var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-between"},[(!_vm.isStudent)?_c('top-bar-notification-list'):_vm._e(),(!_vm.isStudent)?_c('top-bar-reminder-list'):_vm._e(),_c('top-bar-avatar-menu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }